import { render, staticRenderFns } from "./payment-tips-dialog.vue?vue&type=template&id=98618b22&scoped=true&"
import script from "./payment-tips-dialog.vue?vue&type=script&lang=ts&"
export * from "./payment-tips-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./payment-tips-dialog.vue?vue&type=style&index=0&id=98618b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98618b22",
  null
  
)

export default component.exports